var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32.9412C26.0279 32.9412 32.9412 26.0279 32.9412 17.5C32.9412 8.97209 26.0279 2.05884 17.5 2.05884C8.97209 2.05884 2.05884 8.97209 2.05884 17.5C2.05884 26.0279 8.97209 32.9412 17.5 32.9412Z",
    fill: "#0099C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.6838 5.14709C36.2304 11.9405 36.154 22.7551 29.4545 29.4546C22.755 36.1541 11.9404 36.2305 5.14697 29.6839C5.22252 29.7623 5.29893 29.8401 5.37625 29.9174C12.1531 36.6942 23.1405 36.6942 29.9173 29.9174C36.6941 23.1406 36.6941 12.1532 29.9173 5.37638C29.84 5.29905 29.7621 5.22264 29.6838 5.14709Z",
    fill: "#0099C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.2381V25.9998H13.7598L24.1099 15.5508L20.3501 11.7863L10 22.2381Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6703 11.4444L24.5424 9.31328C24.1188 8.89588 23.4271 8.89447 23.0007 9.31469L21.2166 11.107L24.9839 14.8767L26.6703 12.9881C27.1099 12.5481 27.1099 11.8839 26.6703 11.4444Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.47657 7.9297) rotate(45) scale(26.4889 21.6552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1a87cc6d442065a4a39fdd865c057c5.svg";
export { ForwardRef as ReactComponent };